<app-dropdown
    [data]="callbackData[0].arg[1]"
    [defaultOptionIndex]="defaultIndex"
    (selectedItemEvent)="selectedItem($event)"
>
</app-dropdown>
